/*
 * Recently viewed - product pages only. Markup in snippets/gbu-recently-viewed.liquid.
 *
 * Each product page records itself (id + handle) in localStorage, newest first. The row is the
 * store's own product card for each of the others, fetched as /products/<handle>?view=gbu-rv
 * (templates/product.gbu-rv.json renders just the card, with the You may also like settings),
 * so price, sale, stock, badges and quick add are always the live ones. A product that no
 * longer exists is dropped. Without storage (a private window, blocked site data) nothing is
 * recorded and the row simply never appears.
 */
(function () {
  if (window.__gbuRv) return;
  window.__gbuRv = true;

  var KEY = 'gbu-rv';
  var KEEP = 12; // remembered
  var SHOW = 6; // drawn - one row of six, like You may also like

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (p) { return p && p.id && p.handle; }) : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, KEEP)));
    } catch (e) {}
  }
  function forget(id) {
    write(read().filter(function (p) { return p.id !== id; }));
  }

  /** The theme's card for one product, or null when the product is gone. */
  function fetchCard(p) {
    return fetch('/products/' + encodeURIComponent(p.handle) + '?view=gbu-rv', { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404) {
          forget(p.id);
          return null;
        }
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var item = doc.querySelector('[data-gbu-rv-card]');
        return item ? { item: item, scripts: doc.querySelectorAll('script[src]') } : null;
      })
      .catch(function () { return null; });
  }

  // A card may bring a component script the page has not loaded yet (scripts parsed from a
  // string never run on their own), so any missing one is added once.
  function loadScripts(nodes) {
    Array.prototype.forEach.call(nodes, function (s) {
      var src = s.getAttribute('src');
      if (!src) return;
      var path = src.split('?')[0];
      var have = Array.prototype.some.call(document.scripts, function (x) { return x.src && x.src.split('?')[0].indexOf(path.replace(/^https?:/, '')) !== -1; });
      if (have) return;
      var tag = document.createElement('script');
      tag.src = src;
      if (s.type) tag.type = s.type;
      document.head.appendChild(tag);
    });
  }

  function draw(root, items) {
    var track = root.querySelector('[data-gbu-rv-track]');
    track.innerHTML = '';
    if (!items.length) {
      root.hidden = true;
      return;
    }
    // Fetched together, placed in viewing order.
    Promise.all(items.map(fetchCard)).then(function (cards) {
      var any = false;
      cards.forEach(function (c) {
        if (!c) return;
        track.appendChild(document.importNode(c.item, true));
        loadScripts(c.scripts);
        any = true;
      });
      root.hidden = !any;
    });
  }

  function init() {
    var root = document.querySelector('[data-gbu-rv]');
    var data = document.querySelector('[data-gbu-rv-current]');
    if (!root || !data) return;
    var current = null;
    try {
      current = JSON.parse(data.textContent);
    } catch (e) {}

    var others = read().filter(function (p) { return !current || p.id !== current.id; });
    draw(root, others.slice(0, SHOW));

    // This page goes to the front of the list for the next one.
    if (current && current.record) {
      write([{ id: current.id, handle: current.handle, t: Date.now() }].concat(others));
    }

    root.querySelector('[data-gbu-rv-clear]').addEventListener('click', function () {
      try {
        localStorage.removeItem(KEY);
      } catch (e) {}
      draw(root, []);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
